import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
// import { filterAsyncRouter } from '@/api/user'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken
} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
// import store from "@/store/index.js"
NProgress.configure({
  showSpinner: false
}) // NProgress Configuration
const whiteList = ['/login', '/auth-redirect', '/registers', '/privacy', '/overviewInformation', '/wantToEdit', '/binding',
  '/bindingYZ', '/patrolPointRecord'] // no redirect whitelist
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()
  let accessRoutes = null
  // let datas =  localStorage.setItem('accessRoutes', '')
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({
        path: '/'
      })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // console.log(router.getRoutes(),'getRouter')
      try {
        // 如果路由已生成/已添加过，就直接放行
        if (store.getters.addRoutes && store.getters.addRoutes.length !== 0) {
          next()
        } else {
          // 先生成并添加动态路由，再通过 replace 重新触发本次导航
          accessRoutes = await store.dispatch('permission/generateRoutes')
          router.addRoutes(accessRoutes)
          next({
            ...to,
            replace: true
          })
        }
      } catch (err) {
        Message(err)
        next(`/login?redirect=${to.path}`)
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next({path:'/404'})
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
